// extracted by css-extract-rspack-plugin
export default {"static":"Static-module__static__PuzqR2W"};